module.exports = __webpack_public_path__ + "img/icon_preview.117eb0ac.png";